// extracted by mini-css-extract-plugin
export default {"element":"InfoBoxAlt-module--element--42db2","container":"InfoBoxAlt-module--container--ab032","list":"InfoBoxAlt-module--list--7c082"};